import { render, staticRenderFns } from "./formCreateCompany.vue?vue&type=template&id=61100a4d"
import script from "./formCreateCompany.vue?vue&type=script&lang=js"
export * from "./formCreateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61100a4d')) {
      api.createRecord('61100a4d', component.options)
    } else {
      api.reload('61100a4d', component.options)
    }
    module.hot.accept("./formCreateCompany.vue?vue&type=template&id=61100a4d", function () {
      api.rerender('61100a4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/companies/components/form/formCreateCompany.vue"
export default component.exports